import logo from "../../assets/logo.png";

export const footerContent = {
    logo,

    companyInfo: {
        description: `Z2S07-73
        Shed No.07 - Zone 2 Al Hamra FZ
        Al Hamra Industrial Free Zone
        RAK, United Arab Emirates`,
    },

    sitemap: {
        title: "Sitemap",
        links: [
            { name: "Home", path: "/" },
            { name: "Products", path: "/products" },
            // { name: "News", path: "/news" },
            { name: "Contact Us", path: "/contact" },
        ],
    },

    socialLinks: [
        { name: "twitter", url: "#" },
        { name: "facebook", url: "#" },
        { name: "google", url: "#" },
        { name: "telegram", url: "#" },
    ],

    copyright: "© 2025 ARSH Industries FZ LLC. All rights reserved.",
};